import { List } from '../List'
import { CommonWork } from '../CommonWork'

export class PerformanceParent extends List {
  constructor(obj) {
    super(Performance, obj)
  }
}

export class Performance {
  constructor(obj) {
    this.id = (obj && obj?.id) || null
    this.commonWork = new CommonWork((obj && obj?.commonWork) || null)
    this.reportDate = (obj && obj?.reportDate) || null
    this.performanceType = (obj && obj?.performanceType) || null
    this.eventType = (obj && obj?.eventType) || null
    this.performanceName = (obj && obj?.performanceName) || null
    this.remark = (obj && obj?.remark) || null
    this.link = (obj && obj?.link) || null
    this.byOrder = (obj && obj?.byOrder) || false
    this.orderNum = (obj && obj?.orderNum) || null
    this.orderDate = (obj && obj?.orderDate) || null
    this.eventFormat = (obj && obj?.eventFormat) || null
    /*    this.participantQuantity = obj && obj?.participantQuantity || null
    this.representatives = obj && obj?.representatives || null*/
  }

  getForAPI() {
    return {
      id: this.id,
      commonWork: this.commonWork.getForAPI(),
      reportDate: this.reportDate,
      performanceType: this.performanceType,
      eventType: this.eventType,
      performanceName: this.performanceName,
      remark: this.remark,
      link: this.link,
      byOrder: this.byOrder,
      orderNum: this.orderNum,
      orderDate: this.orderDate,
      eventFormat: this.eventFormat
      /*      participantQuantity: this.participantQuantity,
      representatives: this.representatives,*/
    }
  }
}
